import IngredientDetails from './IngredientDetails';
export default IngredientDetails;
